export const FIRM = {
  name: "SHARMA BOOK CENTER",
  tagline: "Leading Book Shop | Publisher & Distributer",
  address: "4, Kamla Market, Kotla Road, Firozabad 283203, UP",
  email: "sharmabookfzd@gmail.com",
  logo: "/logo.png",
};
